import {Typography} from '@material-ui/core';
import {useQuoteField} from 'Quoting/components/hooks/useHandleQuoteFieldChange';
import {A360ProductCd} from 'Quoting/models/Quoting';
import {isDefined, safeRenderValue} from 'Quoting/utils/utilities';
import {Map as ImmutableMap} from 'immutable';
import React, {useMemo} from 'react';
import {useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';
import {PlansFormCard} from './SelectPlansSidebar';
import {getAccidentBlocks} from './products/ACC';
import {getCriticalIllnessBlocks} from './products/CriticalIllness';
import {getPermanentLifeBlocks} from './products/GWL';
import {getHospitalIndemnityBlocks} from './products/HI';
import {AvailablePlans} from './products/types';
import { GPLUCoverageCode } from './PlanTemplates/GWL/gpluConstants';

const getBlocksByProductAndPlan = (productCd: A360ProductCd, plan: AvailablePlans, selectedLifeCoverage: GPLUCoverageCode) => {
  switch (productCd) {
    case A360ProductCd.ACC:
      return getAccidentBlocks(plan);
    case A360ProductCd.CI:
      return getCriticalIllnessBlocks(plan);
    case A360ProductCd.HI:
      return getHospitalIndemnityBlocks(plan);
    case A360ProductCd.GPLU:
      return getPermanentLifeBlocks(plan, selectedLifeCoverage);
    default:
      return [];
  }
};

export const PlanForm = () => {
  const {selectedProduct, isLoadingPlanForm, selectedPlan, selectedLifeCoverage} = useSelector((state: ReducerState) => state.quoteForm);
  const {getQuoteFieldValue, quote} = useQuoteField();
  const selectedPlanDetails = getQuoteFieldValue<ImmutableMap<string, any>>(
    `benefitPackagingDetail.plans[${selectedPlan?.planIndex ?? 0}]`
  );
  const formTitle = `${safeRenderValue(selectedPlanDetails?.get('planName'))} (${safeRenderValue(
    selectedPlanDetails?.get('planCd')
  )})`;

  const blocks = useMemo(() => {
    if (selectedPlan) {
      return getBlocksByProductAndPlan(selectedProduct?.code, selectedPlanDetails?.get('planCd') as AvailablePlans, selectedLifeCoverage as GPLUCoverageCode);
    }
    return [];
  }, [selectedProduct?.code, selectedPlan, quote, selectedLifeCoverage]);

  if (!isLoadingPlanForm && isDefined(selectedPlan?.planIndex) && selectedPlan?.planIndex >= 0 && blocks.length > 0) {
    return (
      <PlansFormCard title={safeRenderValue(formTitle)}>
        {blocks.map(({FormBlock, key, hidden}) =>
          hidden ? null : <FormBlock key={`${key}-${selectedPlan?.planIndex}-${selectedPlan?.planKey}`} />
        )}
      </PlansFormCard>
    );
  }

  return <Typography>No Plans Selected.</Typography>;
};
